import * as classnames from "classnames";
import * as React from "react";

import { Header, HeaderType } from "../../shared/components";
import ApplicantInitialModel from "../../shared/models/ApplicantInitial.model";
import ApplicantSharingExamModel from "../../shared/models/ApplicantSharingExam.model";

/**
 * Routes
 */
import UserRoute from "./UserRoute";

/**
 * Prop interface
 */
export interface UserContainerProps {
  language: string;
  initial: ApplicantInitialModel;
  initialShared: ApplicantSharingExamModel;

  changeLanguage: (locale: string) => void;
}

/**
 * Container component
 */
class UserContainer extends React.Component<UserContainerProps> {
  constructor(props: UserContainerProps) {
    super(props);
  }

  public render() {
    const rootStyle = classnames("code-user-container");

    return (
      <div className={rootStyle}>
        <Header
          type={HeaderType.User}
          language={this.props.language}
          onChangeLanguage={this.props.changeLanguage}
          orgLogo={
            this.props.initial.organizationImageUrl ||
            this.props.initialShared.organizationImageUrl
          }
          orgName={
            this.props.initial.examName ||
            this.props.initial.organizationName ||
            this.props.initialShared.organizationDisplayName
          }
        />
        <div className="code-user-container__body">
          <UserRoute />
        </div>
      </div>
    );
  }
}

export default UserContainer;
